/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { CreateTransmittalRecordInputDto } from './createTransmittalRecordInputDto.schema';

export const CreateTransmittalRecord = zod.object({
  "payload": zod.lazy(() => CreateTransmittalRecordInputDto).optional()
});

export type CreateTransmittalRecord = zod.input<typeof CreateTransmittalRecord>;
export type CreateTransmittalRecordOutput = zod.output<typeof CreateTransmittalRecord>;
